import script from "./NewServerReservation.vue?vue&type=script&setup=true&lang=js"
export * from "./NewServerReservation.vue?vue&type=script&setup=true&lang=js"

import "./NewServerReservation.vue?vue&type=style&index=0&id=14eacac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14eacac2"]])

export default __exports__